var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c(
        "el-card",
        {
          staticClass: "ivu-mt",
          attrs: {
            bordered: false,
            shadow: "never",
            "body-style": { padding: 0 },
          },
        },
        [
          _c(
            "div",
            { ref: "tableheader", staticClass: "padding-add" },
            [
              _c(
                "el-form",
                {
                  ref: "searchForm",
                  attrs: {
                    inline: "",
                    size: "small",
                    model: _vm.searchForm,
                    "label-width": "80px",
                    "label-position": _vm.labelPosition,
                  },
                },
                [
                  !_vm.collapse
                    ? _c(
                        "div",
                        { staticClass: "acea-row search-form" },
                        [
                          _c(
                            "div",
                            { staticClass: "search-form-box" },
                            [
                              _c(
                                "el-form-item",
                                {
                                  attrs: {
                                    label: "活动名称：",
                                    "label-for": "activityName",
                                  },
                                },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "200px" },
                                    attrs: {
                                      placeholder: "请输入活动名称",
                                      clearable: "",
                                    },
                                    model: {
                                      value: _vm.searchForm.activityName,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "activityName",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.activityName",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "关联集市：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "200px" },
                                      attrs: {
                                        filterable: "",
                                        remote: "",
                                        "reserve-keyword": "",
                                        placeholder: "请选择或搜索集市",
                                        "remote-method": _vm.searchMarkets,
                                        loading: _vm.marketLoading,
                                        clearable: "",
                                      },
                                      on: { focus: _vm.loadDefaultMarkets },
                                      model: {
                                        value: _vm.searchForm.marketId,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "marketId",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.marketId",
                                      },
                                    },
                                    _vm._l(
                                      _vm.marketOptions,
                                      function (market) {
                                        return _c(
                                          "el-option",
                                          {
                                            key: market.id,
                                            attrs: {
                                              label: market.marketName,
                                              value: market.id,
                                            },
                                          },
                                          [
                                            _c(
                                              "span",
                                              {
                                                staticStyle: { float: "left" },
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(market.marketName)
                                                ),
                                              ]
                                            ),
                                            _c(
                                              "span",
                                              {
                                                staticStyle: {
                                                  float: "right",
                                                  color: "#8492a6",
                                                  "font-size": "13px",
                                                },
                                              },
                                              [_vm._v(_vm._s(market.street))]
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "活动状态：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择活动状态",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.status,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "status",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.status",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "上架", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "下架", value: 1 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "进程状态：" } },
                                [
                                  _c(
                                    "el-select",
                                    {
                                      staticStyle: { width: "150px" },
                                      attrs: {
                                        placeholder: "请选择进程状态",
                                        clearable: "",
                                      },
                                      model: {
                                        value: _vm.searchForm.processStatus,
                                        callback: function ($$v) {
                                          _vm.$set(
                                            _vm.searchForm,
                                            "processStatus",
                                            $$v
                                          )
                                        },
                                        expression: "searchForm.processStatus",
                                      },
                                    },
                                    [
                                      _c("el-option", {
                                        attrs: { label: "未开始", value: 0 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "进行中", value: 1 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "已结束", value: 2 },
                                      }),
                                      _c("el-option", {
                                        attrs: { label: "已取消", value: 3 },
                                      }),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                              _c(
                                "el-form-item",
                                { attrs: { label: "报名时间：" } },
                                [
                                  _c("el-date-picker", {
                                    staticStyle: { width: "350px" },
                                    attrs: {
                                      type: "datetimerange",
                                      "range-separator": "至",
                                      "start-placeholder": "开始时间",
                                      "end-placeholder": "结束时间",
                                      format: "yyyy-MM-dd HH:mm:ss",
                                      "value-format": "yyyy-MM-dd HH:mm:ss",
                                    },
                                    model: {
                                      value: _vm.searchForm.dateRange,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.searchForm,
                                          "dateRange",
                                          $$v
                                        )
                                      },
                                      expression: "searchForm.dateRange",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { staticClass: "search-form-sub" },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.handleSearchList },
                                },
                                [_vm._v("搜索")]
                              ),
                              _c(
                                "el-button",
                                {
                                  staticClass: "ResetSearch",
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.handleReset("searchForm")
                                    },
                                  },
                                },
                                [_vm._v("重置")]
                              ),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    : _vm._e(),
                ]
              ),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-card",
        {
          staticClass: "box-card mt14",
          attrs: {
            "body-style": { padding: "20px" },
            shadow: "never",
            bordered: false,
          },
        },
        [
          _c("div", { staticClass: "acea-row row-between-wrapper mb15" }, [
            _c("div", { staticClass: "header-title" }, [_vm._v("活动列表")]),
            _c(
              "div",
              { staticClass: "header-btn" },
              [
                _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "hasPermi",
                        rawName: "v-hasPermi",
                        value: ["merchant:market_activity:save"],
                        expression: "['merchant:market_activity:save']",
                      },
                    ],
                    attrs: {
                      type: "primary",
                      size: "small",
                      icon: "el-icon-plus",
                    },
                    on: { click: _vm.handleAdd },
                  },
                  [_vm._v(" 新增活动 ")]
                ),
              ],
              1
            ),
          ]),
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.listLoading,
                  expression: "listLoading",
                },
              ],
              ref: "table",
              staticStyle: { width: "100%" },
              attrs: {
                data: _vm.tableData.data,
                size: "mini",
                height: _vm.tableHeight,
                "highlight-current-row": "",
              },
            },
            [
              _c("el-table-column", {
                attrs: { prop: "id", label: "ID", width: "70", align: "right" },
              }),
              _c("el-table-column", {
                attrs: { label: "状态", width: "80", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type:
                                scope.row.status === 0 ? "success" : "danger",
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  scope.row.status === 0 ? "正常" : "下架"
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "活动图片", width: "80" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "demo-image__preview line-heightOne" },
                          [
                            _vm.getFirstImage(scope.row.activityImg)
                              ? _c("el-image", {
                                  staticStyle: {
                                    width: "50px",
                                    height: "50px",
                                    "border-radius": "4px",
                                  },
                                  attrs: {
                                    src: _vm.getFirstImage(
                                      scope.row.activityImg
                                    ),
                                    "preview-src-list": _vm.parseImageList(
                                      scope.row.activityImg
                                    ),
                                    fit: "cover",
                                  },
                                })
                              : _c(
                                  "div",
                                  {
                                    staticStyle: {
                                      width: "50px",
                                      height: "50px",
                                      "border-radius": "4px",
                                      background: "#f5f7fa",
                                      display: "flex",
                                      "align-items": "center",
                                      "justify-content": "center",
                                      color: "#909399",
                                      "font-size": "12px",
                                    },
                                  },
                                  [_vm._v(" 无图片 ")]
                                ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "活动名称",
                  "min-width": "150",
                  prop: "activityName",
                },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-popover",
                          {
                            attrs: {
                              trigger: "hover",
                              placement: "right",
                              "open-delay": 800,
                            },
                          },
                          [
                            _c(
                              "div",
                              {
                                staticClass: "text_overflow",
                                attrs: { slot: "reference" },
                                slot: "reference",
                              },
                              [_vm._v(_vm._s(scope.row.activityName))]
                            ),
                            _c("div", { staticClass: "pup_card" }, [
                              _vm._v(_vm._s(scope.row.activityName)),
                            ]),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "进程状态", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "el-tag",
                          {
                            attrs: {
                              type: _vm.getProcessStatusType(
                                scope.row.processStatus
                              ),
                              size: "mini",
                            },
                          },
                          [
                            _vm._v(
                              " " +
                                _vm._s(
                                  _vm.getProcessStatusName(
                                    scope.row.processStatus
                                  )
                                ) +
                                " "
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: {
                  label: "集市ID",
                  width: "80",
                  align: "center",
                  prop: "marketId",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "招募摊位数",
                  width: "100",
                  align: "center",
                  prop: "needCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "报名人数",
                  width: "100",
                  align: "center",
                  prop: "applyCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "浏览数据",
                  width: "100",
                  align: "center",
                  prop: "readCount",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "押金",
                  width: "80",
                  align: "center",
                  prop: "deposit",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  label: "履约保证金",
                  width: "110",
                  align: "center",
                  prop: "performanceBond",
                },
              }),
              _c("el-table-column", {
                attrs: { label: "抽成比例", width: "100", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [_vm._v(" " + _vm._s(scope.row.commission) + "% ")]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "报名时间", width: "200", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "line-height": "1.4",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-weight": "500" } },
                              [
                                _vm._v(
                                  "开始：" +
                                    _vm._s(scope.row.startTime || "未设置")
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "2px" } },
                              [
                                _vm._v(
                                  "结束：" +
                                    _vm._s(scope.row.endTime || "未设置")
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "集市时间", width: "200", align: "center" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          {
                            staticStyle: {
                              "font-size": "12px",
                              "line-height": "1.4",
                            },
                          },
                          [
                            _c(
                              "div",
                              { staticStyle: { "font-weight": "500" } },
                              [
                                _vm._v(
                                  "开始：" +
                                    _vm._s(
                                      scope.row.marketStartTime || "未设置"
                                    )
                                ),
                              ]
                            ),
                            _c(
                              "div",
                              { staticStyle: { "margin-top": "2px" } },
                              [
                                _vm._v(
                                  "结束：" +
                                    _vm._s(scope.row.marketEndTime || "未设置")
                                ),
                              ]
                            ),
                          ]
                        ),
                      ]
                    },
                  },
                ]),
              }),
              _c("el-table-column", {
                attrs: { label: "创建时间", width: "150", prop: "createTime" },
              }),
              _c("el-table-column", {
                attrs: { label: "操作", width: "250", fixed: "right" },
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function (scope) {
                      return [
                        _c(
                          "div",
                          { staticClass: "action-buttons" },
                          [
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "merchant:market_activity_apply:save",
                                        ],
                                        expression:
                                          "['merchant:market_activity_apply:save']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleAddApply(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 报名 ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["merchant:market_activity:info"],
                                    expression:
                                      "['merchant:market_activity:info']",
                                  },
                                ],
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDetail(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 详情 ")]
                            ),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["merchant:market_activity:update"],
                                    expression:
                                      "['merchant:market_activity:update']",
                                  },
                                ],
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleEdit(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 编辑 ")]
                            ),
                            scope.row.status === 1
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "merchant:market_activity:publish",
                                        ],
                                        expression:
                                          "['merchant:market_activity:publish']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePublish(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 上架 ")]
                                )
                              : _vm._e(),
                            scope.row.status === 0
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "merchant:market_activity:pullDown",
                                        ],
                                        expression:
                                          "['merchant:market_activity:pullDown']",
                                      },
                                    ],
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handlePullDown(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 下架 ")]
                                )
                              : _vm._e(),
                            scope.row.processStatus !== 3
                              ? _c(
                                  "el-button",
                                  {
                                    directives: [
                                      {
                                        name: "hasPermi",
                                        rawName: "v-hasPermi",
                                        value: [
                                          "merchant:market_activity:cancel",
                                        ],
                                        expression:
                                          "['merchant:market_activity:cancel']",
                                      },
                                    ],
                                    staticStyle: { color: "#e6a23c" },
                                    attrs: { size: "mini", type: "text" },
                                    on: {
                                      click: function ($event) {
                                        return _vm.handleCancel(scope.row)
                                      },
                                    },
                                  },
                                  [_vm._v(" 取消 ")]
                                )
                              : _vm._e(),
                            _c(
                              "el-button",
                              {
                                directives: [
                                  {
                                    name: "hasPermi",
                                    rawName: "v-hasPermi",
                                    value: ["merchant:market_activity:delete"],
                                    expression:
                                      "['merchant:market_activity:delete']",
                                  },
                                ],
                                staticStyle: { color: "#f56c6c" },
                                attrs: { size: "mini", type: "text" },
                                on: {
                                  click: function ($event) {
                                    return _vm.handleDelete(scope.row)
                                  },
                                },
                              },
                              [_vm._v(" 删除 ")]
                            ),
                          ],
                          1
                        ),
                      ]
                    },
                  },
                ]),
              }),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "acea-row row-center-wrapper mt15" },
            [
              _c("el-pagination", {
                attrs: {
                  "current-page": _vm.tableFrom.page,
                  "page-sizes": [10, 20, 30, 40],
                  "page-size": _vm.tableFrom.limit,
                  layout: "total, sizes, prev, pager, next, jumper",
                  total: _vm.tableData.total,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-drawer",
        {
          staticClass: "activity-detail-drawer",
          attrs: {
            title: "活动详情",
            visible: _vm.detailDrawerVisible,
            direction: "rtl",
            size: "70%",
            "before-close": _vm.handleDetailClose,
          },
          on: {
            "update:visible": function ($event) {
              _vm.detailDrawerVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.detailLoading,
                  expression: "detailLoading",
                },
              ],
              staticClass: "drawer-content",
            },
            [
              _vm.currentActivityDetail
                ? _c("ActivityDetail", {
                    attrs: { "activity-data": _vm.currentActivityDetail },
                  })
                : _c("div", { staticClass: "no-data" }, [
                    _c("i", { staticClass: "el-icon-warning" }),
                    _c("span", [_vm._v("暂无详情数据")]),
                  ]),
            ],
            1
          ),
        ]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "cancel-dialog",
          attrs: {
            title: "取消活动",
            visible: _vm.cancelDialogVisible,
            width: "500px",
            "before-close": _vm.closeCancelDialog,
          },
          on: {
            "update:visible": function ($event) {
              _vm.cancelDialogVisible = $event
            },
          },
        },
        [
          _c(
            "div",
            { staticClass: "cancel-dialog-content" },
            [
              _c("div", { staticClass: "warning-info" }, [
                _c("i", {
                  staticClass: "el-icon-warning",
                  staticStyle: {
                    color: "#e6a23c",
                    "font-size": "20px",
                    "margin-right": "8px",
                  },
                }),
                _c(
                  "span",
                  { staticStyle: { color: "#e6a23c", "font-weight": "500" } },
                  [_vm._v("确认要取消该活动吗？取消后不可恢复！")]
                ),
              ]),
              _c(
                "el-form",
                {
                  staticStyle: { "margin-top": "20px" },
                  attrs: { model: _vm.cancelForm, "label-width": "80px" },
                },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: "取消备注：", required: "" } },
                    [
                      _c("el-input", {
                        staticStyle: { width: "100%" },
                        attrs: {
                          type: "textarea",
                          rows: 4,
                          placeholder: "请输入取消原因...",
                          maxlength: "200",
                          "show-word-limit": "",
                        },
                        model: {
                          value: _vm.cancelForm.cancelRemark,
                          callback: function ($$v) {
                            _vm.$set(_vm.cancelForm, "cancelRemark", $$v)
                          },
                          expression: "cancelForm.cancelRemark",
                        },
                      }),
                      _c("div", { staticClass: "form-tips" }, [
                        _vm._v(
                          "请详细说明取消活动的原因，此信息将记录在系统中"
                        ),
                      ]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.closeCancelDialog } }, [
                _vm._v("取消"),
              ]),
              _c(
                "el-button",
                {
                  attrs: { type: "warning" },
                  on: { click: _vm.confirmCancel },
                },
                [_vm._v("确认取消")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }